// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { sq_personalise } from 'src/lib/personalisation.js';


// Stateful components

export class NavigationMenu extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {};

        // Binds
        this.clickHandler = this.clickHandler.bind(this);
    }

    componentDidMount() {
        var this_component = this;
        
    }


    //
    // Events
    //

    clickHandler(event) {
        event.preventDefault();

        var this_component = this;
        var portal_context = this_component['context'];
        var helpers = portal_context['helpers'];

        var user_personalisation = portal_context['user_personalisation'];
        user_personalisation['attributes']['NAME'] = 'MY TeSt';
        
        helpers.updatePersonalisation(user_personalisation);
    }


    //
    // Functions
    //

    getMainClass(current_page) {
        
    }


    //
    // Render
    //

    renderMainNavigation() {

    }

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var viewport = portal_context['viewport'];
        var current_page = portal_context['current_page'];
        var all_pages = portal_context['all_pages'];
        var user_personalisation = portal_context['user_personalisation'];
        
        if(user_personalisation !== null) {
            var filtered_list = sq_personalise.fn.filterItems(all_pages, user_personalisation['attributes']);

            return (
                <div className="navigation__wrapper">
                    
                </div>
            );
        }

        return null;
    }

};

NavigationMenu.contextType = PortalContext;
